module.exports = __webpack_public_path__ + "img/no_image.7a2efddc.png";